import * as THREE from "three";

export const MODEL_MAT = {
  color: 0xcacac9, // 0xb3b3b3,
  emissive: 0x323232,
  roughness: 0.8,
  metalness: 0.05,
  opacity: 1,
  envMapIntensity: 1.4,
  transparent: false
  // vertexColors: true
};

export const MODEL_HIGHLIGHT_MAT = {
  color: 0x4e955d, // 0xb3b3b3,
  emissive: 0x3d7243,
  roughness: 0.8,
  metalness: 0.05,
  opacity: 1,
  envMapIntensity: 1.4,
  transparent: false
  // vertexColors: true
};

export const MODEL_SELECTED_MAT = {
  color: 0x04751c, // 0xb3b3b3,
  emissive: 0x323232,
  roughness: 0.8,
  metalness: 0.05,
  opacity: 1,
  envMapIntensity: 1.4,
  transparent: false
  // vertexColors: true
};

export const SKYBOX_MAT = {
  transparent: false,
  side: THREE.BackSide
};

// Asset path constants for 3D models used in Scene component
export const ASSET_PATHS = {
  // Platform assets
  platform: "/resources/platform_18spp.glb",
  // Skybox assets
  spheretest: "/resources/skyBox/spheretest.obj"
};
export const eMatType = {
  BASIC: 0,
  PHONG: 1,
  PHYSICAL: 2,
  STANDARD: 3,
  MATCAP: 4
};
